const plantilla = localStorage.getItem('layout');

export default plantilla;